// extracted by mini-css-extract-plugin
module.exports = {"navigation":"menu-module--navigation--3xilR","list":"menu-module--list--3-29c"};